import { Suspense, useEffect } from "react"

// ** Third Party Components
import { useTranslation } from "react-i18next"

// ** Routes
import AppRoutes from "./routes/routes"

// ** Styles
import "react-day-picker/dist/style.css"

// ** Helpers
import { cn } from "@pma/utils/helpers"

// ** Custom Hooks
import useTranslator from "@hooks/use-translator"

// ** Custom Components
import { Toaster } from "@components/common/toaster"
import { TooltipProvider } from "@components/common/tooltip"
import { RecaptchaWrapper } from "@components/auth/recaptcha"
import { WarningsProvider } from "./contexts/WarningsContext"
import PmsLoader from "./components/common/loader"

const App = () => {
  const { locale } = useTranslator()
  const { i18n } = useTranslation()
  const isHebrew = locale === "he"

  useEffect(() => {}, [i18n.language])

  return (
    <div className={cn(`min-h-screen overflow-y-auto overflow-x-hidden`, isHebrew ? "rtl" : "ltr")}>
      <WarningsProvider>
        <Suspense fallback={<PmsLoader label='Loading' />}>
          <TooltipProvider delayDuration={0} skipDelayDuration={300} disableHoverableContent>
            <RecaptchaWrapper>
                <AppRoutes />
            </RecaptchaWrapper>
          </TooltipProvider>
          <Toaster />
        </Suspense>
      </WarningsProvider>
    </div>
  )
}

export default App
